<script setup>
import { useSlots } from "vue";

const props = defineProps({
  icon_name: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    required: false,
  },
});

const slots = useSlots();
</script>

<template>
  <div>
    <span :class="['material-symbols-outlined', size ? `text-${size}` : '']">
      {{ icon_name }}
    </span>
    <span class="tooltip-text" v-if="slots.tooltip">
      <slot name="tooltip" />
    </span>
  </div>
</template>

<style lang="scss" scoped>
div {
  align-items: center;
  display: flex;
  justify-content: center;
  user-select: none;

  .tooltip-text {
    @include ff-text;
    @include rounded-borders-lg;

    visibility: hidden;
    position: absolute;
    right: 0;
    color: var(--clr-text-light);
    background-color: var(--clr-bg-dark);
    padding: 0.5rem 1rem;
    z-index: 1;
    transform: translate(calc(100% - 10px), 50%);
  }

  &:hover > .tooltip-text {
    transition-property: visibility;
    transition-delay: 500ms;
    visibility: visible;
  }
}

.text-xs {
  font-size: 0.75rem;
}

.text-sm {
  font-size: 0.875rem;
}

.text-base {
  font-size: 1rem;
}

.text-lg {
  font-size: 1.125rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.text-3xl {
  font-size: 1.875rem;
}

.text-4xl {
  font-size: 2.25rem;
}

.text-10xl {
  font-size: 8rem;
}
</style>
